import React, {Component} from "react";
import {observer} from "mobx-react";
import {mesAutobind} from "@posco/posco-shared";
import {Button, Checkbox, DatePicker, Input, Label, SearchBox, Select, TextArea} from "@posco/posco-ui-react";
import {Common, FindUserModal, UserSearchInput} from "@plm/o10-share-front";


@mesAutobind
@observer
class DetailSearchComponent extends Component {

  state = {
    //상세검색
    headerDetail: false,
    openList: false,
    fromDate: "",
    toDate: "",
    chk1: false,
    chk2: false,
    invLevel: {
      Reveiw: false,
      Approve: false,
      Complete: false,
      Releaseold: false,
      Hold: false
    },
    workLevel: {
      P: false,
      K: false,
      A: false,
    },

    //CODE010/020 OPTIONS
    bizTypeCodeOption: [],
    invCategoryOptions: [],
    investPurposeCodeOption: [],

    // multi input
    multiTextBox01: false, //1투자접수번호,
    multiValue01: [],
    multiTextBox02: false, //2투자코드,
    multiValue02: [],
    multiTextBox03: false, //3공장구분
    multiValue03: [],

    // multi 멤버검색
    employeeHolder1: [],
    employeeNum: [],
    userModalOpen: false,

    // multi select
    investCategoryCode: [], //투자목적
    plmMemberResponKey: [], //역할검색
    bizTypeCode: [],
    investProgLevelName: [],
    worksCode: [],
    investPurposeCode: [],
  }
  componentDidMount() {
    Common.InitUtil.init("o10g014320");
  }
  componentDidUpdate() {
    this.state.investProgLevelName = [];

    for (const key in this.state.invLevel) {
      if (this.state.invLevel[key]) {
        this.state.investProgLevelName.push(key);
      }
    }

    this.state.worksCode = [];

    for (const key in this.state.workLevel) {
      if (this.state.workLevel[key]) {
        this.state.worksCode.push(key);
      }
    }
  }

  onSearch() {
    console.log('this.state', this.state)
    const { multiValue01, multiValue02, multiValue03, bizRegCode, projectNumber, eqpEpcdFacNm, investmetRegistNmInDetailSearchBox, bizTypeCode, investCategoryCode, investProgLevelName, worksCode, investPurposeCode, employeeNum, plmMemberResponKey, fromDate, toDate, plmDetailSrcText} = this.state;
    //multi 가공
    const multi01str = (multiValue01).join(",");//투자접수번호
    const multi02str = (multiValue02).join(",");//투자코드
    const multi03str = (multiValue03).join(",");//공장구분
    const multiBizTypeCode = (bizTypeCode).join(",");//사업유형
    const multiInvestCategoryCode = (investCategoryCode).join(",");//투자부문
    const multIinvestProgLevelName = (investProgLevelName).join(",");//진행구분
    const multiWorksCode = (worksCode).join(",");//사소구분
    const multiInvestPurposeCode = (investPurposeCode).join(",");//투자목적,
    const multiEmployeeNum = (employeeNum).join(",");//멤버
    const multiPlmMemberResponKey = (plmMemberResponKey).join(",");//역할

    let valueMap = {
      "BIZ_REG_CODE": !multiValue01 ? "" : multi01str, //투자접수번호
      "PROJECT_NUMBER": !multiValue02 ? "" : multi02str, //투자코드
      "EQP_EPCD_FAC_NM": !multiValue03 ? "" : multi03str, //공장구분
      "INVESTMET_REGIST_NM": !investmetRegistNmInDetailSearchBox ? "" : investmetRegistNmInDetailSearchBox, //사업명
      "BIZ_TYPE_CODE": !bizTypeCode ? "" : multiBizTypeCode, //사업유형
      "INVEST_CATEGORY_CODE": !investCategoryCode ? "" : multiInvestCategoryCode, //투자부문
      "INVEST_PROG_LEVEL_NAME": !investProgLevelName ? "" : multIinvestProgLevelName, //진행구분
      "WORKS_CODE": !worksCode ? "" : multiWorksCode, //사소구분
      "INVEST_PURPOSE_CODE": !investPurposeCode ? "" : multiInvestPurposeCode, //투자목적
      "PLMMEMBER_MEMB": !employeeNum ? "" : multiEmployeeNum, //멤버검색
      "PLMMEMBER_RESPON_KEY": !plmMemberResponKey ? "" : multiPlmMemberResponKey, //역할검색
      "P_START120": !fromDate ? "" : fromDate, //일정검색
      "P_END120": !toDate ? "" : toDate, //일정검색
      "keyword" : !plmDetailSrcText? "" : plmDetailSrcText
    };

    console.log("valueMap", valueMap);

    //검색 조건 Null 체크
    let keys = Object.keys(valueMap);
    let checkNull = true;
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      if (valueMap[key]) {
        checkNull = false;
      }
    }

    if (checkNull) {
      alert("검색어를 입력해주세요.");
    } else {
      this.props.detailSearchApi(valueMap);
      this.props.headerDetailChange(); //상세창 닫고
      document.getElementById("headerSrcText").value = "" //헤더에 있는 통합검색 키워드는 지움
      console.log(valueMap);
      this.onSearchAfterReset()
    }
  }

  onSearchAfterReset(){
    this.setState({
      headerDetail: false,
      // openList: false,
      // fromDate: "",
      // toDate: "",
      // chk1: false,
      // chk2: false,
      // invLevel: {
      //   Reveiw: false,
      //   Approve: false,
      //   Complete: false,
      //   Releaseold: false,
      //   Hold: false
      // },
      // workLevel: {
      //   P: false,
      //   K: false,
      //   A: false,
      // },

      // //CODE010/020 OPTIONS
      // bizTypeCodeOption: [],
      // invCategoryOptions: [],
      // investPurposeCodeOption: [],

      // // multi input
      // multiTextBox01: false, //1투자접수번호,
      // multiValue01: [],
      // multiTextBox02: false, //2투자코드,
      // multiValue02: [],
      // multiTextBox03: false, //3공장구분
      // multiValue03: [],

      // // multi 멤버검색
      // employeeHolder1: [],
      // employeeNum: [],
      // userModalOpen: false,

      // // multi select
      // investCategoryCode: [], //투자목적
      // plmMemberResponKey: [], //역할검색
      // bizTypeCode: [],
      // investProgLevelName: [],
      // worksCode: [],
      // investPurposeCode: [],

      // plmDetailSrcText: "",
      // investmetRegistNmInDetailSearchBox: "",

    })
  }

  /************일정 검색From*/
  changedfromDate(changedDate) {
    this.setState({ fromDate: changedDate });
  };

  changedToDate(changedDate) {
    this.setState({ toDate: changedDate });
  };

  //일정 검색
  handleChange(e, data) {
    this.setState(data.changed);
  }

  //진행구분
  handleInvLevelChange(e, data) {
    console.log('## 진행구분', e, data)
    this.state.invLevel[data.name] = data.changed[data.name];

    this.setState(this.state);
  }
  //사소구분
  handleWorkLevelChange(e, data) {
    console.log('## 사소구분', e, data)
    this.state.workLevel[data.name] = data.changed[data.name];
    this.setState(this.state);
  }

  headerDetailChange() {
    this.props.headerDetailChange()
  }



  /**************************
 * input 다중 입력
 **************************/
  handleTextBox(num, name) {
    this.setState({ [`multiTextBox${num}`]: !this.state[`multiTextBox${num}`] });

    if (this.state[`multiTextBox${num}`] === false) { //열려있을 때 textArea focus
      window.setTimeout(function () {
        document.getElementById(name).focus();
      }, 0);
    }
  };

  /**************************
   * input 멀티 입력 onChange
   **************************/
  handleMultiValue(e, num) {
    let lines = e.target.value.split("\n");
    lines.filter(item => item); //

    this.setState({ [`multiValue${num}`]: lines });
  };

  onBlurFunc(num) {
    this.setState({ [`multiTextBox${num}`]: false }); //다른곳을 클릭하면 textArea 닫힘
    console.log('this.state', this.state)
  }

  /**************************
   * select onChange
   ***************************/
  async onChange(e, data) {
    if (data.id) {
      this.state[data.id] = data.value;
    } else if (data.name) {
      this.state[data.name] = data.value;
    }
    this.setState(this.state);
  }



  //사용자 modal
  onCloseModal() {
    this.setState({ userModalOpen: false });
  }
  setModalOpen() {
    this.setState({ userModalOpen: true });
  }
  /****************************************
     * 사용자 찾기 Modal
     ****************************************/
  userApplyFunc(params) {
    console.log("userSearchParams",params);

    let tmpEmpHolder = [...this.state.employeeHolder1];
    let tmpEmpNum = [...this.state.employeeNum];
    for (let i of params){
      let newEmpHolder = {
        employeeNumber: i.employeeNumber,
        employeeName: i.employeeName,
      }
      let newUserEmpNum = i.employeeNumber
      tmpEmpHolder.push(newEmpHolder);
      tmpEmpNum.push(newUserEmpNum);
    }
    this.setState({
      employeeHolder1: tmpEmpHolder,
      employeeNum: tmpEmpNum,
      userModalOpen: false
    });
  }

  /**************************
   * 자동 이름 검색(UserSearchInput)
   **************************/
  onClickHandlerUserSearch(params) {
    this.state.employeeHolder1.push(params);
    this.state.employeeNum.push(params.employeeNumber);
  }

  clearUserSearch(e) {    //자동이름 삭제
    let employeeNum = this.state.employeeNum.filter(item => item !== e.employeeNumber);
    this.state.employeeNum = employeeNum;
    this.setState({ employeeHolder1: this.state.employeeHolder1.filter(item => item.employeeNumber !== e.employeeNumber) });
  }


  /* ============================================================*/
  render() {
    const {
      navState, menuList,
      //selectList
      invCategoryOptions, bizTypeCodeOption, investPurposeCodeOption, dpList,
      //checkBox
      workCodeList, investProgLevelNameList,
    } = this.props;
    const {
      openList, fromDate, toDate, chk1, chk2, invLevel, workLevel,

    } = this.state;

    //상세검색창 options
    const options = {
      option01: [
        {value: "_1", text: "선택01"},
        {value: "_2", text: "선택02"},
        {value: "_3", text: "선택03"}
      ],
      option02: [
        {value: "_4", text: "선택01"},
        {value: "_5", text: "선택02"},
        {value: "_6", text: "선택03"}
      ],
      option03: [
        {value: "등록일", text: "등록일"},
        {value: "승인일", text: "승인일"},
        {value: "계약일", text: "계약일"},
        {value: "착공일", text: "착공일"},
        {value: "시운전", text: "시운전"},
        {value: "준공일", text: "준공일"},
        {value: "평가일", text: "평가일"}
      ]
    };

    return (

      <div className="headerSrcBox withSrcBox" ref={this.props.innerRef}>
        <SearchBox
          toggleDisabled
          defaultButtonHidden
          buttonAdditionalNode={
            <>
              <Button className="btnPrm mgr-8" onClick={this.onSearch}>조회</Button>
              <Button className="btn3rd" onClick={this.headerDetailChange}>취소</Button>
            </>
          }
        >
          <SearchBox.Fields className="topLine">
            <SearchBox.Field  name="plmDetailSrcText" className="flex2">
            <Label>검색어</Label>
            <div className={"addDelete"}>
                <Input id="plmDetailSrcText" width={'100%'} onChange={this.onChange} value={this.state.plmDetailSrcText} />
              </div>
            </SearchBox.Field>
          </SearchBox.Fields>
          {/* ---------------------------------------------- */}
          <SearchBox.Fields className="topLine">
            <SearchBox.Field name="bizRegCode" >
              <Label>투자접수번호</Label>
              {/* <Input id={"bizRegCode"} onChange={this.onChange} /> */}
              <div className={"addDelete"}>
                <TextArea
                  style={{ "display": this.state.multiTextBox01 ? "block" : "none", "width": "inherit", "top": "30px" }}
                  className="multiTextBox"
                  onChange={(e) => { this.handleMultiValue(e, "01") }}
                  onBlur={(e) => { this.onBlurFunc("01") }}
                  id={"bizRegCodeBox"}
                />
                <span className="textBox" onClick={(e) => { this.handleTextBox("01", "bizRegCodeBox") }}>{this.state.multiValue01.join()}</span>
                <Button className="btnDelete" style={{ "right": "4px" }}
                  onClick={() => { this.setState({ multiValue01: [""] }), document.getElementById("bizRegCodeBox").value = "" }} />
              </div>
            </SearchBox.Field>
            <SearchBox.Field name="projectNumber"  className="flex2">
              <Label>투자코드</Label>
              <div className={"addDelete"}>
                <TextArea
                  style={{ "display": this.state.multiTextBox02 ? "block" : "none", "width": "inherit", "top": "30px" }}
                  className="multiTextBox"
                  onChange={(e) => { this.handleMultiValue(e, "02") }}
                  onBlur={(e) => { this.onBlurFunc("02") }}
                  id={"projectNumberBox"}
                />
                <span className="textBox" onClick={(e) => { this.handleTextBox("02", "projectNumberBox") }}>{this.state.multiValue02.join()}</span>
                <Button className="btnDelete" style={{ "right": "4px" }}
                  onClick={() => { this.setState({ multiValue02: [""] }), document.getElementById("projectNumberBox").value = "" }} />
              </div>
            </SearchBox.Field>
            <SearchBox.Field name="eqpEpcdFacNm">
              <Label>공장구분</Label>
              {/* <Input id={"eqpEpcdFacNm"} onChange={this.onChange} /> */}
              <div className={"addDelete"}>
                <TextArea
                  style={{ "display": this.state.multiTextBox03 ? "block" : "none", "width": "inherit", "top": "30px" }}
                  className="multiTextBox"
                  onChange={(e) => { this.handleMultiValue(e, "03") }}
                  onBlur={(e) => { this.onBlurFunc("03") }}
                  id={"eqpEpcdFacNmBox"}
                />
                <span className="textBox"  onClick={(e) => { this.handleTextBox("03", "eqpEpcdFacNmBox") }}>{this.state.multiValue03.join()}</span>
                <Button className="btnDelete" style={{ "right": "4px" }}
                  onClick={() => { this.setState({ multiValue03: [""] }), document.getElementById("eqpEpcdFacNmBox").value = "" }} />
              </div>
            </SearchBox.Field>
          </SearchBox.Fields>
          {/* ======================================== */}
          <SearchBox.Fields>
            <SearchBox.Field name="investmetRegistNm">
              <Label>사업명</Label>
              <div className={"addDelete"}>
                {/* investmetRegistNm_In_Detail_SearchBox */}
                <Input id="investmetRegistNmInDetailSearchBox" width={192} onChange={this.onChange} value={this.state.investmetRegistNmInDetailSearchBox} />
                <Button className="btnDelete" style={{ "right": "4px" }}
                  onClick={() => { this.setState({ investmetRegistNmInDetailSearchBox: "" }), document.getElementById("investmetRegistNmInDetailSearchBox").value = "" }} />
              </div>
            </SearchBox.Field>
            <SearchBox.Field name="bizTypeCode"  className="flex2">
              <Label>사업유형</Label>
              <div className="ag-custom-select-edit" style={{ width: "100%", overflow: "hidden" }}>
                <Select
                  className={"multipleChk"}
                  multiple
                  selection
                  scrolling
                  placeholder={"전체"}  //전체
                  options={bizTypeCodeOption}
                  //options={options.option01}
                  value={this.state.bizTypeCode}
                  onChange={this.onChange}
                  id={"bizTypeCode"}
                 // width={272}
                />
              </div>
            </SearchBox.Field>
          </SearchBox.Fields>
          {/* ======================================== */}
          <SearchBox.Fields>
            <SearchBox.Field name="investCategoryCode" className="multiple">
              <Label>투자부문</Label>
              {/* <Input id={"investCategoryCode"} onChange={this.onChange} /> */}
              <div className="ag-custom-select-edit" style={{ width: "100%", overflow: "hidden" }}>
                <Select
                  className={"multipleChk scroll"}
                  multiple
                  selection
                  scrolling
                  placeholder={"전체"}  //전체
                  //options={options.option01}
                  options={invCategoryOptions}
                  value={this.state.investCategoryCode}
                  onChange={this.onChange}
                  id={"investCategoryCode"}
                />
              </div>
            </SearchBox.Field>
            <SearchBox.Field name="investProgLevelName">
              <Label>진행구분</Label>
              <>
                {investProgLevelNameList && investProgLevelNameList.map((v, i) => {
                  return <Checkbox label={`${v.text}`} name={`${v.value}`} checked={invLevel[`${v.value}`]} onChange={this.handleInvLevelChange} />
                })}
              </>
            </SearchBox.Field>
          </SearchBox.Fields>
          {/* ======================================== */}
          <SearchBox.Fields>
            <SearchBox.Field name="worksCode">
              <Label>사소구분</Label>
              <>
                {workCodeList && workCodeList.map((v, i) => {
                  return <Checkbox label={`${v.text}`} name={`${v.value}`} checked={workLevel[`${v.value}`]} onChange={this.handleWorkLevelChange} />
                })}
                {/* <Checkbox label="포항" value={"P"} checked={workLevel.P} onChange={this.handleWorkLevelChange} />
                <Checkbox label="광양" value={"K"} checked={workLevel.K} onChange={this.handleWorkLevelChange} />
                <Checkbox label="본사" value={"A"} checked={workLevel.A} onChange={this.handleWorkLevelChange} /> */}
              </>
            </SearchBox.Field>
            <SearchBox.Field name="investPurposeCode" className="flex2">
              <Label>투자목적</Label>
              {/* <Select options={options.option01} /> */}
              <div className="ag-custom-select-edit" style={{ width: "100%", overflow: "hidden" }}>
                <Select
                  className={"multipleChk scroll"}
                  multiple
                  selection
                  scrolling
                  placeholder={"전체"}  //전체
                  //options={options.option01}
                  options={investPurposeCodeOption}
                  value={this.state.investPurposeCode}
                  onChange={this.onChange}
                  id={"investPurposeCode"}
                 // width={300}
                />
              </div>
            </SearchBox.Field>
          </SearchBox.Fields>
          {/* ======================================== */}
          <SearchBox.Fields className="topLine">
            <SearchBox.Field name="plmMemberMemb" className="flex2">
              <Label>멤버검색</Label>
              <div className="addDelete">
                <UserSearchInput
                  gcsCompCode={Common.PotalUtil.getStorageItem('Posco.auth.userInfo').gcsCompCode}
                  onClick={this.onClickHandlerUserSearch}
                  onRemove={this.clearUserSearch}
                  paramUserList={this.state.employeeHolder1}
                  width={100}
                />
                <Button className="btnInputSearch" onClick={() => {
                  this.setModalOpen();
                }} />
              </div>
            </SearchBox.Field>
          </SearchBox.Fields>
          <SearchBox.Fields>
            <SearchBox.Field name="plmMemberResponKey" className="multiple">
              <Label>역할검색</Label>
              {/* <Select options={options.option02} /> */}
              <div className="ag-custom-select-edit" style={{ width: "100%", overflow: "hidden" }}>
                <Select
                  multiple
                  selection
                  scrolling
                  className={"multipleChk scroll"}
                  placeholder={"전체"}  //전체
                  options={dpList}
                  value={this.state.plmMemberResponKey}
                  onChange={this.onChange}
                  id={"plmMemberResponKey"}
                  width={300}
                />
              </div>
            </SearchBox.Field>
            <SearchBox.Field name="checkbox4" className="mgl-8">
              <Label>일정검색</Label>
              <>
                <span className="mgl-8 mgr-4">From</span>
                <DatePicker
                  onChange={this.changedfromDate}
                  value={fromDate}
                  max={toDate}
                >
                  <Input icon="calendar alternate outline"
                  //  width={120}
                  />
                </DatePicker>

                <span className="mgl-8 mgr-4">To</span>

                <DatePicker
                  onChange={this.changedToDate}
                  value={toDate}
                  min={fromDate}
                >
                  <Input icon="calendar alternate outline"
                  // width={120}
                  />
                </DatePicker>
              </>
            </SearchBox.Field>
          </SearchBox.Fields>
        </SearchBox>

        <FindUserModal
          close={() => this.onCloseModal()}
          open={this.state.userModalOpen}
          onApply={this.userApplyFunc}
          gcsCompCode={sessionStorage.getItem('gcsCompCode')}
          vendorId={'3050'}
          onlyActive={true}
          multi={true}
        />
      </div>
    )
  }
}

export default DetailSearchComponent;
